import type {
  ReservationFormMainContext,
  ReservationFormMainEvent,
} from '../reservationFormMain.types';

import { canSaveAsDraftFromFormValues } from './canSaveAsDraftFromFormValues';

export function canSaveAsDraftFromEvent({
  context,
  event,
}: {
  context: ReservationFormMainContext;
  event: ReservationFormMainEvent;
}): boolean {
  if (event.type !== 'SAVE_AS_DRAFT') {
    return false;
  }
  if (!context.clientBC?.trim() || !context.passengerUUID?.trim()) {
    return false;
  }
  return canSaveAsDraftFromFormValues(event.formValues);
}
